import React, { useState } from "react";
import {
	Alert,
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Grid,
	TextField,
	Typography,
} from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PreviewPdfViewer from "./PreviewPdfViewer";

export const DEFAULT_PREVIEW_PAYLOAD = {
	first_name: "Jane",
	last_name: "Doe",
	business_name: "Jane Properties Ltd",
	phone_number: "0771234567",
	landlord_payment_mode: "MOBILE_MONEY",
	landlord_payment_account: "0771234567",
	landlord_mobile_registered_name: "Jane Doe",
	payout_frequency: "MONTHLY",
	pay_day: "7",
};

const PreviewDialog = ({ open, onClose, onPreview, isPreviewing, previewResult, error }) => {
	const [form, setForm] = useState(DEFAULT_PREVIEW_PAYLOAD);

	const handlePreview = () => {
		onPreview(form);
	};

	const previewUrl = previewResult?.preview_document_url;
	const variables = previewResult?.variables;

	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
			<DialogTitle>Preview filled agreement</DialogTitle>
			<DialogContent>
				<Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
					Sample landlord data is sent to the API. Resolved variables are printed on the PDF at your saved
					positions.
				</Typography>
				{error && (
					<Alert severity="error" sx={{ mb: 2 }}>
						{error}
					</Alert>
				)}
				<Grid container spacing={2}>
					{Object.keys(DEFAULT_PREVIEW_PAYLOAD).map((key) => (
						<Grid item xs={12} sm={6} key={key}>
							<TextField
								fullWidth
								size="small"
								label={key.replace(/_/g, " ")}
								value={form[key] ?? ""}
								onChange={(e) => setForm((f) => ({ ...f, [key]: e.target.value }))}
							/>
						</Grid>
					))}
				</Grid>

				{variables && (
					<Box mt={3}>
						<Typography variant="subtitle2" gutterBottom>
							Resolved variables
						</Typography>
						<Box
							component="pre"
							sx={{
								fontSize: "0.75rem",
								bgcolor: "grey.100",
								p: 1.5,
								borderRadius: 1,
								overflow: "auto",
								maxHeight: 160,
							}}
						>
							{JSON.stringify(variables, null, 2)}
						</Box>
					</Box>
				)}

				{previewUrl && (
					<Box mt={2}>
						<Button
							variant="outlined"
							startIcon={<OpenInNewIcon />}
							href={previewUrl}
							target="_blank"
							rel="noopener noreferrer"
							sx={{ mb: 1 }}
						>
							Open preview in new tab
						</Button>
						<PreviewPdfViewer url={previewUrl} />
					</Box>
				)}
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>Close</Button>
				<Button variant="contained" onClick={handlePreview} disabled={isPreviewing}>
					{isPreviewing ? "Generating…" : "Generate preview"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default PreviewDialog;
